const root = {
  padding: 0,
};

const styleOverrides = {
  root,
};

export { styleOverrides };
